import React from 'react';
import { Modal, Button, Form, Divider, DatePicker } from 'antd';
import { _success, _setAxios } from '../../../../lib/Helper';
import moment from 'moment';

const { RangePicker } = DatePicker;
const dateFormat = 'DD-MM-YYYY';

class Export extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            values: {},
        };
    }

    handleChangeSetValue = (name, value) => {
        const { values } = this.state;
        this.setForm(values, name, value)
    };

    setForm = (values, name, value) => {
        values[name] = value;

        this.setState({
            values: values,
        });
    }

    handleSubmit = () => {
        this.setState({
            loading: true
        });
        _setAxios("keuangan/pengeluaran/master/ekspor", "POST", this.state.values).then(resp => {
            if (resp.status === true) {
                this.props.hideModal()
                _success('topRight', 'Success', resp.data.message)
                setTimeout(function () {
                    window.location.href = resp.data.data.link;
                }, 1000);
            }
            this.setState({
                loading: false
            });
        })
    };

    render() {
        return (
            <Modal
                title="Export data pengeluaran"
                visible={this.props.visible}
                onCancel={this.props.hideModal}
                footer={<>
                    <Button onClick={this.props.hideModal}>Batal</Button>
                    <Button type="primary" htmlType="submit" onClick={this.handleSubmit} loading={this.state.loading}>Export</Button>
                </>}
            >
                <Form
                    name="basic"
                    autoComplete="off"
                    layout="vertical"
                >
                    <Form.Item label="Tanggal Transaksi">
                        <RangePicker
                            style={{
                                width: "100%", borderRadius: 4, padding: "6px 10px"
                            }}
                            format={dateFormat}
                            onChange={val => {
                                if (!val || val.length === 0) {
                                    this.props.setTempTableFilter("tgl_awal", null)
                                    this.props.setTempTableFilter("tgl_akhir", null)

                                    return
                                }

                                let periodeAwal = moment(val[0]).format(dateFormat)
                                let periodeAkhir = moment(val[1]).format(dateFormat)

                                this.handleChangeSetValue("tgl_awal", periodeAwal)
                                this.handleChangeSetValue("tgl_akhir", periodeAkhir)
                            }}
                        />
                    </Form.Item>
                    <Divider />
                    <div style={{ textAlign: "left" }}>Data yang diekspor akan langsung diunduh tanpa melalui log export. Apakah Anda yakin?</div>
                </Form>
            </Modal>
        )
    }
}

export default Export;
